import { Button, Image } from 'antd';
import styles from 'styles/components/addToSlackButton.module.scss';
import { getSLackURL } from 'utils/utils';

const AddToSlackButton = ({ size = 'default', param = '' }) => {
  const url = getSLackURL(param);
  return (
    <a href={url} target="_blank" rel="noreferrer">
      <Button
        size={size}
        type={'primary'}
        icon={<Image src="/img/slack_80.png" width={20} preview={false} />}
        className={styles.addToSlackButton}
      >
        Add to Slack
      </Button>
    </a>
  );
};

export default AddToSlackButton;
